import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeContent'
})
export class SafeContentPipe implements PipeTransform {

  transform(value: any) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  constructor(private sanitizer: DomSanitizer) { }

}
